(function() {
    'use strict';

    var module = angular.module('doclr.afspraak.monitor', [/*'doclr.agendabeheerderuser', 'doclr.praktijk',*/ 'ui.bootstrap']);

    module.factory('afspraakMonitor', function($uibModal, notificationService, userContext) {

        function select(element) {
            var selectedText;

            if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
                element.focus();
                element.setSelectionRange(0, element.value.length);

                selectedText = element.value;
            }
            else {
                if (element.hasAttribute('contenteditable')) {
                    element.focus();
                }

                var selection = window.getSelection();
                var range = document.createRange();

                range.selectNodeContents(element);
                selection.removeAllRanges();
                selection.addRange(range);

                selectedText = selection.toString();
            }

            return selectedText;
        }

        function deselectAll() {
            var selection = window.getSelection();
            selection.removeAllRanges();
        }


        var toonWijziging = function(action, afspraak) {
            function maakWijzigingText(action, afspraak) {
                if (userContext.isTeleSecretariaat()) {
                    if (userContext.username === 'agenda@offitel.be'){
                        return `OFFITEL ONL APP\nActie: ${action}\nNaam: ${afspraak.naam}\nVoornaam: ${afspraak.voornaam ? afspraak.voornaam : ''}\nDag: ${afspraak.dag}\nVan: ${afspraak.van}\nTot: ${afspraak.tot}\nGeboortedatum: ${afspraak.geboortedatum ? afspraak.geboortedatum : ''}\nTelefoonnummer: ${afspraak.telefoon ? afspraak.telefoon : ''}\nEmail: ${afspraak.email ? afspraak.email : ''}\nReden: ${afspraak.reden ? afspraak.reden : ''}`;
                    } else if (userContext.username === 'meldingen@solutel.be') {
                        return `Solutel\nActie: ${action}\nNaam: ${afspraak.naam}\nVoornaam: ${afspraak.voornaam ? afspraak.voornaam : ''}\nDag: ${afspraak.dag}\nVan: ${afspraak.van}\nTot: ${afspraak.tot}\nGeboortedatum: ${afspraak.geboortedatum ? afspraak.geboortedatum : ''}\nTelefoonnummer: ${afspraak.telefoon ? afspraak.telefoon : ''}\nEmail: ${afspraak.email ? afspraak.email : ''}\nReden: ${afspraak.reden ? afspraak.reden : ''}`;
                    }
                    return `TELESECRETARIAAT\nActie: ${action}\nNaam: ${afspraak.naam}\nVoornaam: ${afspraak.voornaam ? afspraak.voornaam : ''}\nDag: ${afspraak.dag}\nVan: ${afspraak.van}\nTot: ${afspraak.tot}\nGeboortedatum: ${afspraak.geboortedatum ? afspraak.geboortedatum : ''}\nTelefoonnummer: ${afspraak.telefoon ? afspraak.telefoon : ''}\nEmail: ${afspraak.email ? afspraak.email : ''}\nReden: ${afspraak.reden ? afspraak.reden : ''}`;
                } else {
                    return `Actie: ${action}\nNaam: ${afspraak.naam}\nVoornaam: ${afspraak.voornaam ? afspraak.voornaam : ''}\nDag: ${afspraak.dag}\nVan: ${afspraak.van}\nTot: ${afspraak.tot}\nGeboortedatum: ${afspraak.geboortedatum ? afspraak.geboortedatum : ''}\nTelefoonnummer: ${afspraak.telefoon ? afspraak.telefoon : ''}\nEmail: ${afspraak.email ? afspraak.email : ''}\nReden: ${afspraak.reden ? afspraak.reden : ''}`;
                }
            }

            $uibModal.open({
                templateUrl: '/partials/afspraakmonitor/afspraakwijziging.html',
                controllerAs: 'ctrl',
                controller: function() {
                    this.action = action;
                    this.afspraak = afspraak;
                    this.wijziging = maakWijzigingText(action, afspraak);
                    this.status = 'default'; // default, success, error
                    this.copyToClipboard = function() {
                        var afspraak = document.getElementById('afspraak-clipboard-source');
                        select(afspraak);
                        try {
                            document.execCommand('copy');
                            deselectAll();
                            if (userContext.isTeleSecretariaat()){
                                document.execCommand('paste');
                                notificationService.showSuccess('Pasted');
                            }
                            this.status = 'success';
                            notificationService.showSuccess(doclrVertaal.instant('modules.afspraakmonitor.copytoclipboard.showSuccess'));
                        }
                        catch (err) {
                            this.status = 'error';
                            notificationService.showWarning(doclrVertaal.instant('modules.afspraakmonitor.copytoclipboard.showSuccess'));
                        }
                    };
                }
            });
        };

        return {
            toonWijziging
        };
    });


})();


